import {MessagingSendChannel, MessagingTemplateId} from "@/libwyze-common/api/types";
import React, {ReactElement, useState} from "react";
import {StyledBoxColumn, StyledBoxColumnWithLabel} from "@/shared/StyledComponents";
import {PAGE_FRAGMENT_WIDTH_SM, PD_XLG} from "@/shared/dimens";
import {Button, TextField, Typography} from "@mui/material";
import {Api} from "../api";
import {BaseApp} from "@/shared/BaseApp";

export function SendWhatsAppDialog({templateId, templateVariables, onSent}: {
  templateId: MessagingTemplateId,
  templateVariables: string[],
  onSent: () => void
}): ReactElement {
  const [whatsapp, setWhatsapp] = useState<string>();
  const [sending, setSending] = useState<boolean>(false);
  return <StyledBoxColumn style={{width: "84dvw", maxWidth: PAGE_FRAGMENT_WIDTH_SM, padding: PD_XLG, gap: PD_XLG}}>
    <Typography variant="h6">Send Whatsapp</Typography>
    <StyledBoxColumnWithLabel label={"Whatsapp address"}>
      <TextField
        inputMode="tel"
        size={"small"}
        value={whatsapp}
        onChange={event => setWhatsapp(event.target.value)}/>
    </StyledBoxColumnWithLabel>
    <Button
      variant="contained"
      disabled={sending}
      onClick={() => {
        setSending(true);
        (async function () {
          try {
            await Api.getInstance().sendMessaging({
              channel: MessagingSendChannel.WHATSAPP,
              fromId: "noreply_dentwyze_in",
              to: whatsapp,
              templateId,
              templateVariables,
            });
            BaseApp.CONTEXT.showToast("Whatsapp message sent!");
            onSent();
          } catch (e) {
            BaseApp.CONTEXT.showToast("Oops, something went wrong.");
          } finally {
            setSending(false);
          }
        })()
      }}>Send</Button>
  </StyledBoxColumn>;
}
